import { ExtraData } from '@models/extra-data.model';
import { Action } from '@ngrx/store';

export const SETEXTRADATA = '[extraData] SETDATOSINICIOEXTRAS';

export const UNSETEXTRADATA = '[extraData] UNSETDATOSINICIOEXTRAS';

export class setExtraData implements Action {
  readonly type = SETEXTRADATA;
  constructor(public datosExtra: ExtraData) {}
}

export class unsetExtraData implements Action {
  readonly type = UNSETEXTRADATA;
}

export type extraDataActions =
  | setExtraData
  | unsetExtraData;
